import React from "react";
import { compose, withActions } from "containers/HOC";
import { Form, Field } from "react-final-form";
import * as FormUtils from "common/FormUtils";
import Modal from "components/new/Modal";
import ModalBody from "components/new/ModalBody";
import ModalFooter from "components/new/ModalFooter";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import InputPack from "components/InputPack";
import SelectPack from "components/SelectPack2";
import { grantFarmAccess } from "./_actions";
import Alert from "components/Alert";

class GrantFarmAccessModal extends React.Component {
    _validate = (values) => {
        const errors = {};

        errors.inviteeEmail = FormUtils.validators.required(values.inviteeEmail);
        errors.inviteeEmail = errors.inviteeEmail || FormUtils.validators.email(values.inviteeEmail);
        errors.inviteeEmail = errors.inviteeEmail || FormUtils.validators.maxLength(255)(values.inviteeEmail);

        errors.role = FormUtils.validators.required(values.role);

        return errors;
    };

    _save = (values) => {
        this.props.grantFarmAccess(values);
        if (this.props.modal.onConfirm) {
            this.props.modal.onConfirm(values);
        }
    };

    render() {
        const { viewModel, refData } = this.props;
        const isAResend = viewModel.inviteeEmail ? true : false;
        const roles = viewModel.canInviteOwner || isAResend ? refData.farmRoles.filter((r) => !["Publication", "PublicationAgent", "Guest"].includes(r.value)) : (refData.farmRoles || []).filter((r) => !["Owner", "Publication", "PublicationAgent", "Guest"].includes(r.value));

        return (
            <Form initialValues={viewModel} validate={this._validate} onSubmit={this._save}>
                {({ values, handleSubmit, submitSucceeded }) => {
                    return (
                        <Modal title="Manage farm access" instructions="Farm access is granted at the organisational level. Enter the email address of the user you are granting access to this farm. All users of their organisation will be granted this access.">
                            {({ closeModal }) => (
                                <form onSubmit={handleSubmit}>
                                    <ModalBody>
                                        <Grid>
                                            <GridCell>
                                                <Field name="id" type="hidden" component="input" />
                                                <Field name="inviteeEmail" label="Email" placeholder="Email address" disabled={isAResend} required type="text" component={InputPack} />
                                            </GridCell>
                                            <GridCell className="u-width1of2">
                                                <Field name="role" label="Access level" placeholder="Select the access level" options={roles} disabled={isAResend} required component={SelectPack} />
                                            </GridCell>
                                        </Grid>
                                        <Alert type="info" text="An organisation granted access may publish analyses and associated data from this farm to themselves or other organisations without further permission. Organisations granted admin or owner permission can provide other organisations with access to this farm." />
                                    </ModalBody>
                                    <ModalFooter>
                                        <div className="ButtonBar">
                                            <div className="ButtonBar-left">
                                                <button id="cancel-button" type="button" className="Button Button--secondary" onClick={closeModal}>
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="ButtonBar-right">
                                                <button id="save-button" type="submit" className="Button" disabled={submitSucceeded}>
                                                    Send
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </form>
                            )}
                        </Modal>
                    );
                }}
            </Form>
        );
    }
}

export default compose(withActions({ grantFarmAccess }))(GrantFarmAccessModal);
